/**
 * @generated SignedSource<<5883fb1edc7ab15af020f0e2872a12f9>>
 * @relayHash fe655b1c8f3fbc00448359fc7bbdb4a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { formatRulesQuery } from './formatRulesQuery.graphql';

const node: PreloadableConcreteRequest<formatRulesQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b",
    "metadata": {},
    "name": "formatRulesQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
